<template>
  <Card title="Megbízások">
    <template v-slot:body>
      <div v-for="(commission, index) in paginatedCommissions"
           :key="index">
        <div class="">
          <h4 class="has-text-weight-normal">{{ (currentPage - 1) * commissionsPerPage + index + 1 }}. megbízás</h4>
          <h6 class="mb-0">Név</h6>
          <div>{{ commission.name }}</div>
          <h6 class="mb-0">Kérdőív</h6>
          <div>{{ commission.survey_name }}</div>
          <h6 class="mb-0">Vizsgált időszak</h6>
          <div>{{ commission.year }}</div>
          <div class="divider my-2"/>
        </div>
      </div>
      <strong v-if="commissions.length === 0">
        Nincs ellenőrzésre kiválasztott megbízás
      </strong>
      <div v-if="totalPages > 1"
           class="pagination-controls">
        <b-button type="is-primary"
                  outlined
                  @click="prevPage"
                  :disabled="currentPage === 1">
          Előző oldal
        </b-button>
        <span>Oldal {{ currentPage }}/{{ totalPages }}</span>
        <b-button type="is-primary"
                  outlined
                  @click="nextPage"
                  :disabled="currentPage === totalPages">
          Következő oldal
        </b-button>
      </div>
    </template>
  </Card>
</template>

<script>
import Card from '@/components/Cards/Common/Card'

export default {
  name: 'CommissionCard',
  components: { Card },
  data () {
    return {
      currentPage: 1,
      commissionsPerPage: 3,
    }
  },
  computed: {
    commissions () {
      return this.$store.state.inspection.selected.details.commissions
    },
    totalPages () {
      return Math.ceil(this.commissions.length / this.commissionsPerPage)
    },
    paginatedCommissions () {
      const start = (this.currentPage - 1) * this.commissionsPerPage
      const end = start + this.commissionsPerPage
      return this.commissions.slice(start, end)
    },
  },
  methods: {
    nextPage () {
      if (this.currentPage < this.totalPages) {
        this.currentPage++
      }
    },
    prevPage () {
      if (this.currentPage > 1) {
        this.currentPage--
      }
    },
  },
}
</script>

<style scoped>
.pagination-controls {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 1rem;
}
</style>
